export const OPEN_TAB_EVENT = 'OPEN_TAB_EVENT';
export const ON_TAB_SELECTION = 'ON_TAB_SELECTION';
export const ON_TAB_CLOSE = 'ON_TAB_CLOSE';
export const ON_TAB_RENAME = 'ON_TAB_RENAME';
export const ON_TAB_MOVE = 'ON_TAB_MOVE';
